/* Bright Bison — "Select a Size" gate.
   Stops a size from being auto-selected and gates the Add-to-Cart button
   until the shopper picks a size. Layered on top of the theme's variant
   logic (does not modify it). Toggle/label/colour come from the
   #bb-size-gate-config element rendered by blocks/_product-details.liquid.
   Note: the size picker lives OUTSIDE the <product-form-component>, so we
   scope to the product-details container and match the option by product id. */
(function () {
  var cfg = document.getElementById('bb-size-gate-config');
  if (!cfg) return;

  var PID = cfg.getAttribute('data-product-id');
  var LABEL = cfg.getAttribute('data-label') || 'Select a Size';
  var COLOR = cfg.getAttribute('data-color') || '#545454';

  var form = document.querySelector('product-form-component[data-product-id="' + PID + '"]');
  if (!form) return;

  var scope = form.closest('.product-details') ||
              form.closest('[data-testid="product-information-details"]') ||
              document;

  function sizeFieldset() {
    var inputs = scope.querySelectorAll('input[type="radio"][name^="Size-"]');
    for (var i = 0; i < inputs.length; i++) {
      if ((inputs[i].name || '').indexOf(PID) !== -1) {
        var fs = inputs[i].closest('fieldset');
        if (fs) return fs;
      }
    }
    return null;
  }

  var fs0 = sizeFieldset();
  if (!fs0) return; // product has no Size option — leave it alone
  if (fs0.querySelectorAll('input[type="radio"]').length < 2) return; // single size

  var chosen = false;

  function btn() { return form.querySelector('[ref="addToCartButton"], button[name="add"]'); }
  function labels(b) { return b ? b.querySelectorAll('.add-to-cart-text__content') : []; }

  function clearSelectedLabel() {
    var fs = sizeFieldset();
    if (!fs) return;
    var sel = fs.querySelector('[data-selected-text-target]');
    if (sel && sel.hasAttribute('data-placeholder')) {
      var ph = sel.getAttribute('data-placeholder');
      if ((sel.textContent || '').trim() !== (ph || '').trim()) sel.textContent = ph;
    }
  }

  function gate() {
    clearSelectedLabel();
    var b = btn(); if (!b) return;
    var ls = labels(b);
    for (var i = 0; i < ls.length; i++) {
      if (!ls[i].hasAttribute('data-bb-orig')) ls[i].setAttribute('data-bb-orig', ls[i].textContent);
      ls[i].textContent = LABEL;
    }
    b.classList.add('bb-size-gate-active');
    b.style.setProperty('background-color', COLOR, 'important');
    b.style.setProperty('border-color', COLOR, 'important');
    // Disable so the theme's add-to-cart handler (and its "Added" animation) can't fire without a size.
    b.disabled = true;
    b.setAttribute('aria-disabled', 'true');
    b.style.setProperty('opacity', '1', 'important');
    b.style.setProperty('cursor', 'not-allowed', 'important');
  }

  function ungate() {
    var b = btn(); if (!b) return;
    var ls = labels(b);
    for (var i = 0; i < ls.length; i++) {
      var o = ls[i].getAttribute('data-bb-orig');
      if (o !== null) ls[i].textContent = o;
    }
    b.classList.remove('bb-size-gate-active');
    b.style.removeProperty('background-color');
    b.style.removeProperty('border-color');
    b.disabled = false;
    b.removeAttribute('aria-disabled');
    b.style.removeProperty('opacity');
    b.style.removeProperty('cursor');
  }

  function deselect(fs) {
    var ins = fs.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < ins.length; i++) { if (ins[i].checked) ins[i].checked = false; }
  }

  // React to variant changes. A real size pick releases the gate; any other
  // option change (e.g. colour, which makes the picker silently re-default the
  // size) re-applies the gate so a size still has to be chosen by hand.
  scope.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    var isSize = t.matches('input[type="radio"][name^="Size-"]') && (t.name || '').indexOf(PID) !== -1;
    // Only a real user click/keypress on a size releases the gate. When colour
    // changes, the picker re-selects a size and fires an UNtrusted change event
    // (e.isTrusted === false) — we must ignore that and re-apply the gate.
    if (isSize && e.isTrusted) {
      chosen = true;
      ungate();
    } else if (!chosen) {
      scheduleReGate();
    }
  }, true);

  // The picker re-renders asynchronously after an option change, so re-assert
  // the gate a few times until it settles.
  function scheduleReGate() {
    [0, 60, 150, 300, 500, 800].forEach(function (d) { setTimeout(ensureGated, d); });
  }

  // The theme dispatches 'variant:update' on document AFTER it re-renders the
  // picker (which silently re-defaults the size when colour changes). This is
  // the reliable hook to re-assert the gate once the picker has settled.
  document.addEventListener('variant:update', function () {
    if (!chosen) scheduleReGate();
  });

  // Block add-to-cart until a size is chosen (capture phase beats the theme handler)
  form.addEventListener('click', function (e) {
    if (chosen) return;
    var target = e.target.closest ? e.target.closest('[ref="addToCartButton"], button[name="add"]') : null;
    if (!target) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var fs = sizeFieldset();
    if (fs) {
      fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fs.style.transition = 'outline .2s ease';
      fs.style.outline = '2px solid ' + COLOR;
      fs.style.outlineOffset = '4px';
      fs.style.borderRadius = '10px';
      setTimeout(function () { fs.style.outline = 'none'; }, 1600);
    }
  }, true);

  // Keep the gate applied. The theme re-renders the picker (re-checking a
  // size) and re-hydrates the button text after we run, so we re-assert until
  // the shopper actually chooses a size.
  function ensureGated() {
    if (chosen) return;
    var fs = sizeFieldset();
    if (fs) deselect(fs); // clear any size the picker re-selected
    var b = btn();
    if (!b) return;
    var ls = labels(b);
    // Re-gate if the button got re-enabled, lost the gate class, or the label was reset.
    var needs = !b.disabled || !b.classList.contains('bb-size-gate-active');
    for (var j = 0; j < ls.length; j++) {
      if ((ls[j].textContent || '').trim() !== LABEL) { needs = true; break; }
    }
    if (needs) gate();
    else clearSelectedLabel();
  }

  ensureGated();
  var mo = new MutationObserver(ensureGated);
  mo.observe(scope, { childList: true, subtree: true });
})();
